import { Color, Icon, IconButton } from '@billy/design-system'
import { MouseEvent, ReactElement, useCallback } from 'react'

import * as Styled from '../TransactionsTable/styles'

interface TransactionsTableOriginLinkProps {
  url: string
  voided?: boolean
}

export const TransactionsTableOriginLink = ({ url, voided }: TransactionsTableOriginLinkProps): ReactElement => {
  const handleClick = useCallback(
    (event: MouseEvent) => {
      event.preventDefault()
      window.open(url, '_blank', 'noopener,noreferrer')
    },
    [url],
  )

  return (
    <Styled.TableCellButtonWrapper>
      <IconButton
        as="a"
        href={url}
        /* a workaround to style icon button, there's a bug in DS */
        icon={<Icon color={voided ? Color.Grey300 : 'currentColor'} icon="squareArrowOutUpRight" size="sm" />}
        onClick={handleClick}
        rel="noopener noreferrer"
        size="sm"
        target="_blank"
      />
    </Styled.TableCellButtonWrapper>
  )
}
